export default "__VITE_ASSET__CtXplBz1__"